import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { useHistory } from 'react-router-dom'

import FaqCategoryItem from './FaqCategoryItem'
import './FaqResultModal.scss'

const FaqResultModal = props => {
  const { toggle, isOpen, faqs = [], modalType } = props

  const history = useHistory()
  const setRoute = faq => {
    const {
      faqId,
      category: { description },
    } = faq

    const path = `faq/${description}/${faqId}`
    history.push(path)
    let source = 'faq modal type unknown'
    if (modalType === 'search') {
      source = 'faq keyword'
    } else if (modalType === 'tagCloud') {
      source = 'faq tag cloud'
    }
    props.handleFaqLog(faqId, source)
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      contentClassName="FaqResultModal faq-slide-modal"
      size="lg"
      style={{ maxWidth: 'none', width: '100%' }}
    >
      <ModalHeader toggle={toggle} />
      <ModalBody>
        {faqs.length > 0 ? (
          <FaqCategoryItem faqs={faqs} handleOnClick={faq => setRoute(faq)} />
        ) : (
          <h5>No result found.</h5>
        )}
      </ModalBody>
    </Modal>
  )
}

export default FaqResultModal
